// const dev = 'http://api-inclusion.ipmotionmc.com/' // 测试
// const prod = 'http://api-inclusion.ipmotionmc.com/' // 测试
// const dev = 'http://api-inclusion.123cgj.com/' // 测试1
// const prod = 'http://api-inclusion.123cgj.com/' // 测试1
const dev = 'https://api2.inclusionconf.com/' // 正式
const prod = 'https://api2.inclusionconf.com/' // 正式

// swagger地址 http://120.26.109.24:11300/swagger-ui.html#/
// 测试服务器地址 120.26.109.24  /inclusion/html/website/

// 外滩大会正式地址 https://web.inclusionconf.com/
const base = process.env.NODE_ENV === "production" ? prod : dev

export default base;



// WEBPACK FOOTER //
// ./src/api/base.js